import { flushSync } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { leaveThen } from '@/shared/hooks/useLeaveGuard';

export const PREVIEW_LANDING = '/dashboard';

/**
 * Entering or leaving a preview never keeps a form alive across the change.
 * Entering goes through the leave flow, so real unsaved edits are saved or
 * asked about, then lands on the dashboard before the preview starts.
 * Leaving navigates away while the preview is still active, so the form
 * unmounts with saving skipped and nothing typed during the preview is
 * persisted, and only then clears the preview.
 */
export function usePreviewTransitions() {
    const navigate = useNavigate();
    const { startPreview, stopPreview } = useAuth();

    const enterPreview = (role) =>
        leaveThen(() => {
            navigate(PREVIEW_LANDING);
            startPreview(role);
        });

    const exitPreview = () => {
        flushSync(() => navigate(PREVIEW_LANDING));
        stopPreview();
    };

    return { enterPreview, exitPreview };
}
